/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../baseClient';
import { 
  ListPayeePromotionalCampaignsResponse,
  ListPayeePromotionalInvoicesByCampaignResponse
 } from '../types';

  //  CorePayeePromotionalCampaignClient
class CorePayeePromotionalCampaignClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly listPayeePromotionalCampaigns = (): AxiosPromise<ListPayeePromotionalCampaignsResponse> => {
        let url_ = "/api/v1/core/payee/promotional_campaigns";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly listPayeePromotionalInvoices = (): AxiosPromise<ListPayeePromotionalInvoicesByCampaignResponse> => {
        let url_ = "/api/v1/core/payee/promotional_campaigns/promotional_invoices";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeePromotionalCampaignClient
  
export const corePayeePromotionalCampaignClient = new CorePayeePromotionalCampaignClient(baseClientConstructorProps);
